import React,{useState} from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import DescriptiveLink from '../GenericFormActions/SubComponents/DescriptiveLink/DescriptiveLink';
import InfoPanel from './SubComponents/InfoPanel/InfoPanel';
import TextInputWrapper from './SubComponents/TextInputWrapper/TextInputWrapper';
import BlackTitlePurpleSubTitle from './SubComponents/BlackTitlePurpleSubTitle/BlackTitlePurpleSubTitle';
import {isArrayValid} from '../../../Assets/functions/functions';

const InfoDeliveryForm = ({
  title,
  purpleSubTitle,
  infoPanelTitle,
  infoPanelContentArr,
  descriptiveLinksArr = [],
  textInputWrapperObj = {},
  textInputObj,
  btnText,
  onClickCallback,
}) => {
  const { wrapperTitle, validityCallback, initialInputValue, errorMessage } = textInputWrapperObj;
  const [showError, setShowError] = useState(false);
  const [inputValue, setInputValue] = useState(initialInputValue || '');

  const handleOnChange = (e) => {
    const value = e.target.value;
    const isValid = validityCallback(value);

    setShowError(!isValid && value.length > 0);

    if (isValid) {
      setInputValue(value);
    }
  };

  const handleOnClick = () => {
    if (!showError && inputValue) {
      onClickCallback(inputValue);
    }
  };
  return (
    <div className='info-delivery-form-container'>
      <div className='info-delivery-form'>
        <BlackTitlePurpleSubTitle title={title} purpleSubTitle={purpleSubTitle} />
        {infoPanelTitle && infoPanelContentArr && <InfoPanel title={infoPanelTitle} contentArr={infoPanelContentArr} />}

        {isArrayValid(descriptiveLinksArr) && (
          <div className='descriptive-links'>
            {descriptiveLinksArr.map((link, index) => (
              <DescriptiveLink key={index} {...link} />
            ))}
          </div>
        )}
        <TextInputWrapper title={wrapperTitle} textInputObj={{...textInputObj, onChange: handleOnChange, error: showError && errorMessage}} />
      </div>
      {btnText && <BtnSubmit text={btnText} onclick={handleOnClick} />}
    </div>
  );
};

export default InfoDeliveryForm;
